import { Typography } from "@mui/material";
import { useContext } from "react";

import { NotificationPageDispatchContext } from "../../context/NotificationsPageProvider";
import { setNotificationFilterType, setShouldFetchNotifications } from "../../state/actions";

import accordionStore  from "./useAccordionStore";

const CustomAccordionListElement = ({ accordionElement }) => {
  const notificationPageEventDispatch = useContext(NotificationPageDispatchContext);
  const toggle = accordionStore((state) => state.toggle);
  const activeId = accordionStore((state) => state.activeId);

  const handleAccordionItemClick = (event, item) => {
    if (item.count >= 0) {
      item.count = 0;
      if (activeId === item.key) {
        toggle(null);
         setNotificationFilterType(notificationPageEventDispatch, {
        selected: null,
        key: item.key,
      });
      } else {
        toggle(null);
        toggle(item.key);
         
         setNotificationFilterType(notificationPageEventDispatch, {
        selected: activeId !== item.key ? item.key : null,
        key: item.key,
      });
      }
      setShouldFetchNotifications(notificationPageEventDispatch, true);
    }
  };
  
  return (
    <div
      className={`group mb-2 flex flex-row items-center justify-between rounded border-l-4 border-white ${
        activeId === accordionElement.key ? "border-l-4 border-purple-500 bg-gray-100" : ""
      } ${
        accordionElement.count > 0
          ? "ml-2 hover:cursor-pointer hover:border-l-4 hover:border-purple-500 hover:bg-gray-100"
          : "px-2"
      }`}
      onClick={(event) => {
        handleAccordionItemClick(event, accordionElement);
      }}
    >
      <div className="p-2">
        <Typography className="text-sm">{accordionElement.label}</Typography>
      </div>
      {accordionElement.count !== 0 ? (
        <div
          className={`mx-2 my-1 flex h-8 w-8 items-center justify-center rounded-full p-2 text-center ${
            activeId === accordionElement.key ? "bg-purple-500 text-white" : "bg-gray-100 text-black"
          } ${
            accordionElement.count > 0 ? "group-hover:bg-purple-500 group-hover:text-white" : ""
          } `}
        >
          <Typography className="text-center align-middle text-sm">
            {accordionElement.count}
          </Typography>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomAccordionListElement;
